// src/pages/Home.js
import React from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Element } from "react-scroll";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import AboutSection from "../components/AboutSection";
import ServicesSection from "../components/ServicesSection";
import ForLawFirms from "../components/ForLawFirms";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import theme from "../components/Theme";  // Import your theme

const Home = () => {
  return (
    <ThemeProvider theme={theme}>  {/* Wrap your Home component with the ThemeProvider */}
      <CssBaseline />
      <Header />
      <Element name="hero">
        <HeroSection />
      </Element>
      <Element name="about">
        <AboutSection />
      </Element>
      <Element name="services">
        <ServicesSection />
      </Element>
      <Element name="for law firmss">
        <ForLawFirms />
      </Element>
      <Element name="contact">
        <ContactSection />
      </Element>
      <Footer />
    </ThemeProvider>
  );
};

export default Home;